export default __webpack_public_path__ + "static/media/lexus.a9fbe81b.svg";